<template>
  <div class="min-h-full flex flex-col">
    <Menubar>
      <template #start>
        <div class="flex items-center">
          <a :href="CmsUrl">
            <img src="@/assets/images/logo.svg" alt="logo" class="px-3" />
          </a>
          <LanguageSwitcher />
        </div>
      </template>
    </Menubar>

    <div class="flex flex-col lg:flex-row flex-1 text-neutral-800 font-sans">
      <div class="flex-1 flex flex-col justify-center px-10 lg:px-[2rem] xl:px-[10rem] py-10">
        <h1 class="text-4xl lg:text-8xl mb-10">{{ $t('translations_for_every_need') }}</h1>
        <h4 class="max-w-[40rem] text-lg">
          {{ $t('login_page_subtitle') }}
        </h4>
      </div>

      <div class="flex flex-1 flex-col justify-stretch">
        <div
          class="flex-1 flex flex-1 flex-col justify-between bg-white px-6 xl:px-16 py-14 m-6 rounded-lg mx-10 shadow-md"
        >
          <div class="flex flex-col items-center pt-10">
            <img
              class="w-[10rem] h-[10rem] w-auto"
              src="@/assets/images/consulting.svg"
              alt="Your Company"
            />
            <h2 class="mt-4 text-5xl font-bold text-gray-900 mb-5">{{ $t('sign_in') }}</h2>
          </div>

          <div class="">
            <LoginForm />
            <div class="mt-5 mb-5 text-center">
              <router-link
                to="/forgot-password"
                class="font-semibold text-royal-400 hover:underline"
              >
                {{ $t('forgot_your_password') }}
              </router-link>
            </div>
          </div>

          <div class="">
            <SocialMediaLoginFormV2 v-if="showNewDesign" :label="$t('oauth.google.login')" />
            <SocialMediaLoginForm v-else-if="showOldDesign" :label="$t('oauth.google.login')" />
          </div>
          <p class="mt-2 text-sm text-center space-x-1 leading-6 text-gray-500">
            <span>{{ $t('no_account_yet') }}</span>
            <router-link to="/register" class="font-semibold text-royal-400 hover:underline">
              {{ $t('sign_up_now') }}
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import LoginForm from '@/components/forms/LoginForm.vue'
import SocialMediaLoginForm from '@/components/forms/SocialMediaLoginForm.vue'
import SocialMediaLoginFormV2 from '@/components/forms/SocialMediaLoginFormV2.vue'
import Menubar from 'primevue/menubar'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { SHOP_URL } from '@/entrypoint'

const CmsUrl = SHOP_URL
const showNewDesign = ref(false)
const showOldDesign = ref(false)

onMounted(() => {
  updateFeatureFlags()
  window.posthog.onFeatureFlags(updateFeatureFlags)
})

const updateFeatureFlags = () => {
  const flagValue = window.posthog.getFeatureFlag('social-auth-login')
  showNewDesign.value = flagValue === 'new_design'
  showOldDesign.value = flagValue === 'old_design'
}
</script>
